import type { SVGProps } from 'react'
const SvgClinicalNotes = (props: SVGProps<SVGSVGElement>) => (
  <svg height="1em" viewBox="0 0 18 18" width="1em" xmlns="http://www.w3.org/2000/svg" {...props}>
    <mask
      height={18}
      id="clinical-notes_svg__a"
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}
      width={18}
      x={0}
      y={0}
    >
      <path d="M0 0h18v18H0z" />
    </mask>
    <g mask="url(#clinical-notes_svg__a)">
      <path d="M12.821 11.879q-.986 0-1.676-.69t-.69-1.677.69-1.676 1.677-.69 1.676.69.69 1.677a2.28 2.28 0 0 1-.69 1.676q-.69.69-1.677.69m.002-1.662a.68.68 0 0 0 .502-.202.69.69 0 0 0 .202-.503.68.68 0 0 0-.203-.503.68.68 0 0 0-.503-.202.68.68 0 0 0-.502.203.69.69 0 0 0-.202.503q0 .3.202.502a.68.68 0 0 0 .503.202M8.205 17.35v-2.292q0-.426.203-.802.204-.375.568-.595.614-.365 1.292-.601a8.6 8.6 0 0 1 1.391-.359l1.163 1.348L13.98 12.7q.711.121 1.383.359.672.236 1.286.601.364.222.577.595.212.372.212.797v2.297zm1.647-1.662h2.185l-.963-1.139q-.32.081-.622.215-.303.135-.6.292zm3.754 0h2.17l.023-.63a4 4 0 0 0-.598-.303 5 5 0 0 0-.632-.206zm-9.802.229q-.708 0-1.208-.499a1.64 1.64 0 0 1-.498-1.207V3.817q0-.708.498-1.207a1.65 1.65 0 0 1 1.208-.499h10.392q.709 0 1.207.499.5.5.5 1.207v3.36a5.6 5.6 0 0 0-.751-.77 2.25 2.25 0 0 0-.956-.477V3.817H3.804V14.21h3.014a3.4 3.4 0 0 0-.113.847v.859zm1.5-9.099h4.882a3.5 3.5 0 0 1 .925-.62 3.7 3.7 0 0 1 1.051-.31v-.57H5.305zm0 2.947h3.682a3.7 3.7 0 0 1 .036-.765q.057-.375.18-.735H5.304zm0 2.946H7.76q.224-.2.484-.352.258-.15.534-.277v-.871H5.304zm-1.5 1.5V3.817v2.098-.27z" />
    </g>
  </svg>
)
export default SvgClinicalNotes
